import styled from 'astroturf/react';

const Clearfix = styled('div')`
  clear: both;
`;

export default {
  Clearfix
};
